/**
 * Extrai a parte final da URL de requisicao do Olinda, i.e., `https://apigatewayolinda.mec.gov.br/api/olinda/consultar-olinda` => `consultar-olinda`, por exemplo.
 * @param {string} olindaURL
 */
function getURLOlindaRequest(olindaURL) {
  if (typeof olindaURL !== "string") {
    throw new TypeError(
      `URL olinda recebida possui problemas de tipagem! Contate um administrador para verificar os detalhes.`
    );
  }

  const regex = /(\/[\w-]+)$/;

  return olindaURL.match(regex)[0].slice(1);
}

export default getURLOlindaRequest;
